import React from 'react'
import PropTypes from 'prop-types'

import { Card, Button, BUTTON_THEME, Icon } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const INFO_OPTIONS = [
  {
    label: 'Oct 2020 New Releases',
    href:
      'https://paper.dropbox.com/doc/Audience-Insights-Updates-Oct-2020--BFf95Yy2POz5iGLUJb2YAkjeAg-5DaX7EP0Mep4VUYpok7Gx',
  },
  {
    label: 'How-to Guide',
    href:
      'https://paper.dropbox.com/doc/Audience-Insights-How-to-Guide--BFd6qQjXN99vZ1Q9pMlRKn4iAg-ut8tTQXaOhB3KWuGUpocP',
  },
  {
    label: 'FAQs',
    href:
      'https://paper.dropbox.com/doc/Audience-Insights-FAQs--BFfQHpn_SDzUroCCtszUYpJHAg-pThHiK0j6Ck8coGn7Q4uG',
  },
  {
    label: 'Best Practices for Custom Insight Slides',
    href: 'https://paper.dropbox.com/doc/Audience-Insights-Best-Practices-fQeNn088Lkdpot5dme1Tz',
  },
  {
    label: 'How-to-Videos',
    href: 'https://sharethis.atlassian.net/wiki/spaces/RI/pages/405667872/How+To+Videos',
  },
]

const MoreInfoDropdown = React.forwardRef(({ onClose }, ref) => {
  return (
    <div ref={ref} className="info__wrapper">
      <Card className="info__content">
        <div className="heading">
          <h1 className="info__title">Information center</h1>
          <Button theme={BUTTON_THEME.GHOST} onClick={onClose}>
            <Icon type="fill" icon="delete" width="24px" height="24px" />
          </Button>
        </div>
        {INFO_OPTIONS.map((info) => (
          <a
            className="info__link"
            href={info.href}
            key={info.label}
            rel="noopener noreferrer"
            target="_blank"
          >
            {info.label}
          </a>
        ))}
      </Card>
    </div>
  )
})

MoreInfoDropdown.propTypes = {
  onClose: PropTypes.func,
}

MoreInfoDropdown.defaultProps = {
  onClose: () => {},
}

MoreInfoDropdown.displayName = 'MoreInfoDropdown'

export default React.memo(MoreInfoDropdown)
